<template>
  <v-chip v-if="params.value" label x-small color="deep-purple darken-1" text-color="white" class="font-weight-bold px-2">
    Non Bonded
  </v-chip>
</template>
<script>
export default {};
</script>
